import { Button } from '@/ui/components/'
import { Badge } from '@/ui/components/'
import { Sparkles } from '@/ui/icons'
import type { FeedCard as FeedCardType } from '@/shared/api'
import { FeedRow } from './FeedRow'

/** The one deliberate solid-accent moment on the feed — reserved for Ranger content. */
export const RANGER_ICON_CHIP = 'bg-adventure-600 text-white'

interface AiRecommendationCardProps {
  card: FeedCardType
  onAskRanger: (tripId?: string) => void
}

/**
 * AI-narrated recommendation from Ranger. Same dashboard row pattern as the rest of
 * the feed, differentiated only by an adventure-tinted icon box and a "Ranger" badge.
 * The action opens the Ranger chat modal pre-seeded with the card's trip context.
 */
export function AiRecommendationCard({ card, onAskRanger }: AiRecommendationCardProps) {
  const subtitle = card.tripName ? (
    <>
      <span className="font-medium text-earth-700 dark:text-earth-300">{card.tripName}</span>
      {' · '}
      {card.body}
    </>
  ) : (
    card.body
  )

  return (
    <FeedRow
      title={card.title}
      subtitle={subtitle}
      icon={Sparkles}
      iconChipClassName={RANGER_ICON_CHIP}
      badge={
        <Badge variant="secondary" className="bg-adventure-100 text-adventure-700 dark:bg-adventure-900/40 dark:text-adventure-300">
          Ranger
        </Badge>
      }
      action={
        <Button size="sm" onClick={() => onAskRanger(card.tripId)}>
          {card.actionText || 'Ask Ranger'}
        </Button>
      }
    />
  )
}
